import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

import { CourseFromGroupApi } from "api";
import { PaziaButton, PaziaFormButton, PaziaInput, PaziaTextarea } from "components/atoms";

export const CATEGORY_FORM_GROUP_NAMES = {
  ID: "id",
  NAME: "name",
  DESCRIPTION: "description",
} as const;

export const categoryFormGroupSchema = yup
  .object({
    [CATEGORY_FORM_GROUP_NAMES.ID]: yup.number(),
    [CATEGORY_FORM_GROUP_NAMES.NAME]: yup.string().required(),
    [CATEGORY_FORM_GROUP_NAMES.DESCRIPTION]: yup.string(),
  })
  .required();

export type CategoryFormGroupSchema = yup.InferType<typeof categoryFormGroupSchema>;

interface CategoryFormGroupFormProps {
  onSubmit: (data: CategoryFormGroupSchema) => Promise<void>;
  group: CourseFromGroupApi | null;
  onCancel: () => void;
}

export const CategoryFormGroupForm = ({ onSubmit, onCancel, group }: CategoryFormGroupFormProps) => {
  const methods = useForm<CategoryFormGroupSchema>({
    resolver: yupResolver(categoryFormGroupSchema),
    defaultValues: {
      [CATEGORY_FORM_GROUP_NAMES.ID]: group?.courseFormGroupId,
      [CATEGORY_FORM_GROUP_NAMES.NAME]: group?.name,
      [CATEGORY_FORM_GROUP_NAMES.DESCRIPTION]: group?.description,
    },
  });

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <PaziaInput name={CATEGORY_FORM_GROUP_NAMES.NAME} label="Nazwa grupy" className="w-full" required />
        <PaziaTextarea name={CATEGORY_FORM_GROUP_NAMES.DESCRIPTION} label="Opis" />
        <div className="flex justify-end gap-2">
          <PaziaButton title="Anuluj" type="tertiary" btnType="button" onClick={onCancel} />
          <PaziaFormButton title="Zapisz" type="success" />
        </div>
      </form>
    </FormProvider>
  );
};
